<h3 mat-dialog-title>Modification</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Machinery Name</mat-label>
            <input matInput type="text" name="machinery_name" [(ngModel)]="trailDocumentModification.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Description</mat-label>
            <textarea matInput type="text" name="description" [(ngModel)]="trailDocumentModification.description"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Modification tested?</mat-label>
            <mat-select name="tested" [(ngModel)]="tested">
                @for (state of testedStates; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Trail updated?</mat-label>
            <mat-select name="tested" [(ngModel)]="trailUpdated">
                @for (state of trailUpdatedStates; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>


    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailDocumentModification" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>
